// Product image zoom: opens PhotoSwipe (full-screen, pinch / double-tap zoom, swipe)
// instead of Dawn's lightbox modal, which crops images and can't be pinch-zoomed on iOS.
// Dawn's zoom button (.product__media-toggle) stays as the trigger; we take over its click.
import PhotoSwipe from './photoswipe.esm.min.js';

function largestSource(img) {
  const candidates = (img.getAttribute('srcset') || '')
    .split(',')
    .map((part) => part.trim().split(/\s+/))
    .filter(([url, w]) => url && w && w.endsWith('w'))
    .map(([url, w]) => ({ url, width: parseInt(w, 10) }));
  if (!candidates.length) return { url: img.currentSrc || img.src, width: img.naturalWidth || 1600 };
  return candidates.reduce((a, b) => (b.width > a.width ? b : a));
}

function slidesFor(gallery) {
  return [...gallery.querySelectorAll('.product__modal-opener--image')].map((opener) => {
    const img = opener.querySelector('.product__media img');
    const { url, width } = largestSource(img);
    const ratio = img.getAttribute('width') && img.getAttribute('height')
      ? img.getAttribute('height') / img.getAttribute('width')
      : img.naturalHeight / img.naturalWidth || 1;
    return { opener, slide: { src: url, width, height: Math.round(width * ratio), alt: img.alt } };
  });
}

// A short hint that the image can be zoomed. Fades out after a few seconds or once the user zooms.
function registerZoomHint(pswp) {
  const touch = window.matchMedia('(pointer: coarse)').matches;
  pswp.ui.registerElement({
    name: 'zoom-hint',
    appendTo: 'root',
    html: touch ? 'Pinch or double-tap to zoom' : 'Click to zoom',
    onInit: (el) => {
      el.setAttribute('aria-hidden', 'true');
      const hide = () => el.classList.add('pt-zoom-hint--hidden');
      const timer = setTimeout(hide, 3500);
      pswp.on('zoomPanUpdate', ({ slide }) => {
        if (slide.currZoomLevel > slide.zoomLevels.initial * 1.01) {
          clearTimeout(timer);
          hide();
        }
      });
    },
  });
}

document.addEventListener(
  'click',
  (event) => {
    const toggle = event.target.closest('.product__modal-opener--image .product__media-toggle');
    const gallery = toggle && toggle.closest('media-gallery');
    if (!gallery) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const items = slidesFor(gallery);
    const index = Math.max(0, items.findIndex((item) => item.opener.contains(toggle)));
    const pswp = new PhotoSwipe({
      dataSource: items.map((item) => item.slide),
      index,
      bgOpacity: 0.85,
      showHideAnimationType: 'fade',
      secondaryZoomLevel: 2,
      maxZoomLevel: 4,
    });
    pswp.on('uiRegister', () => registerZoomHint(pswp));
    pswp.init();
  },
  true
);
